import { lazyLoad } from 'utils/loadable';

export const UserProfile = lazyLoad(
  () => import('./userProfile.page'),
  (module) => module.UserProfile
);
